import React from 'react';

interface PerformanceMetricProps {
  value: string;
  label: string;
  color?: 'green' | 'blue' | 'purple' | 'orange';
}

export const PerformanceMetric: React.FC<PerformanceMetricProps> = ({
  value,
  label,
  color = 'green',
}) => {
  const colorClasses = {
    green: 'text-green-600',
    blue: 'text-blue-600',
    purple: 'text-purple-600',
    orange: 'text-orange-600',
  };

  return (
    <div className="text-center p-4 border rounded-lg">
      <p className={`text-2xl font-bold ${colorClasses[color]}`}>{value}</p>
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
};
